import Container from '@zenbusiness/zui/Container';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const KlarnaLandingContainer = superstyled({
  name: 'KlarnaLanding',
  slot: 'container',
  tag: Container,
  propsAdded: {
    maxWidth: 'sm'
  },
  styles: ({ theme }) => ({
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6)
  })
});

export const KlarnaLandingCompanyName = superstyled({
  name: 'KlarnaLanding',
  slot: 'companyName',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'xs',
    uppercase: true,
    weight: 'medium'
  }
});

export const KlarnaLandingSubtitle = superstyled({
  name: 'KlarnaLanding',
  slot: 'subtitle',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'md'
  },
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1)
  })
});

export const KlarnaLandingEmptyState = superstyled({
  name: 'KlarnaLanding',
  slot: 'emptyState',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'md'
  }
});
